module.exports = __webpack_public_path__ + "static/changedfeatures-3ef9bfdfce6d78a08d353f649e537bb7.png";